import ActionsDetail from '@/components/actions-detail/index.vue';
import IssueFileList from './../../views/issue-details/issue-filelist/index.vue';
import YuriTimeline from '@/components/yuri-timeline/index.vue';
import IssueAlerts from '@/components/issue-alert/index.vue';

const components = {
    ActionsDetail,
    IssueFileList,
    YuriTimeline,
    IssueAlerts
};

export default components;
